export class Logger {
  static logError = (error: unknown, message?: string) => {
    console.error(message ?? error, error);
  };
}
